 /* global $:true */

import React, { PropTypes, Component } from 'react';

class ToolTip extends Component {
    componentDidMount() {
        $('a[data-toggle="tooltip"]').tooltip({
            animated: 'fade',
            placement: 'right',
        });
    }

    render() {
        const { text } = this.props;
        return (
            <a data-toggle="tooltip" title={text} style={{ marginLeft: '5px' }}>
                <i className="fa fa-info-circle" />
            </a>
        );
    }
}

ToolTip.propTypes = {
    text: PropTypes.string.isRequired
};

export default ToolTip;



/** WEBPACK FOOTER **
 ** ./src/elements/ToolTip.js
 **/